{{#EACH-COLS settings 1 'ct-available-fields'}}
	&#8226;&nbsp;{{this}}
{{/EACH-COLS}}
{{#unless settings}}{{TR 'alles'}}{{/unless}}
